export const FORM_CONTROL_HEIGHT = 'h-14'
export const FORM_CONTROL_WIDTH = 'md:max-w-lg'
export const FORM_CONTROL_BG = 'bg-profileInput'
export const FORM_RADIUS = 'rounded-3xl'

export const FORM_CONTROL_CLASS = `${FORM_CONTROL_HEIGHT} ${FORM_CONTROL_WIDTH} ${FORM_CONTROL_BG} ${FORM_RADIUS} w-full relative text-white p-4 px-6 border-0 focus:outline-none text-base`

export const FORM_CONTROL_BG_COLOR = '#242d36'
